import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/login/Login';
import Layout from './components/main-interface/Layout';
import TwoFactorVerify from './components/auth/TwoFactorVerify';
import TwoFactorSetup from './components/auth/TwoFactorSetup';
import ForcePasswordChange from './components/auth/ForcePasswordChange';
import { AuthProvider } from './AuthContext';
import ErrorPage from './components/main-interface/pages/ErrorPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/2fa/verify" element={<TwoFactorVerify />} />
          <Route path="/2fa/setup" element={<TwoFactorSetup />} />
          <Route path="/first-login" element={<ForcePasswordChange />} />
          <Route path="/layout/*" element={<Layout />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
